export default "__VITE_ASSET__CZlZA3Yn__"